/* Farm Made Organics Co. · shared behaviour. No dependencies. */
(() => {
  const doc = document.documentElement;
  doc.classList.add("js");
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* header: hide on the way down, return on the way up */
  const header = document.querySelector(".site-header");
  let lastY = scrollY, ticking = false;
  const onScroll = () => {
    const y = scrollY;
    if (header && !document.body.classList.contains("menu-open")) {
      if (y > 240 && y > lastY + 4) header.classList.add("is-hidden");
      else if (y < lastY - 4 || y < 240) header.classList.remove("is-hidden");
    }
    lastY = y; ticking = false;
  };
  addEventListener("scroll", () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });

  /* mobile menu */
  const menuBtn = document.querySelector(".menu-btn");
  const mnav = document.querySelector(".mobile-nav");
  if (menuBtn && mnav) {
    const set = (open) => {
      menuBtn.setAttribute("aria-expanded", String(open));
      mnav.classList.toggle("is-open", open);
      document.body.classList.toggle("menu-open", open);
      document.body.style.overflow = open ? "hidden" : "";
    };
    menuBtn.addEventListener("click", () => set(menuBtn.getAttribute("aria-expanded") !== "true"));
    mnav.addEventListener("click", (e) => { if (e.target.closest("a")) set(false); });
    addEventListener("keydown", (e) => { if (e.key === "Escape") set(false); });
  }

  /* reveals: once, on entry */
  const ins = document.querySelectorAll("[data-in], [data-wipe]");
  document.querySelectorAll("[data-in]").forEach((el) => [...el.children].forEach((c, i) => c.style.setProperty("--i", i)));
  if ("IntersectionObserver" in window && !reduce) {
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); }
    }), { rootMargin: "0px 0px -12% 0px", threshold: 0.01 });
    ins.forEach((el) => io.observe(el));
  } else ins.forEach((el) => el.classList.add("is-in"));

  /* table of contents: highlight the section being read */
  const toc = document.querySelectorAll(".toc a[href^='#']");
  if (toc.length && "IntersectionObserver" in window) {
    const map = new Map([...toc].map((a) => [a.getAttribute("href").slice(1), a]));
    const tio = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { toc.forEach((a) => a.classList.remove("is-active")); map.get(en.target.id)?.classList.add("is-active"); }
    }), { rootMargin: "-20% 0px -70% 0px" });
    map.forEach((_, id) => { const s = document.getElementById(id); if (s) tio.observe(s); });
  }

  /* coverage calculator · label rate 1–2 oz per 1,000 sq ft; prices from the store */
  const PRICE = { j128: 39.99, j32: 17.99 };
  const fmt = (n, d = 0) => n.toLocaleString("en-US", { minimumFractionDigits: d, maximumFractionDigits: d });
  document.querySelectorAll("[data-calc]").forEach((calc) => {
    const input = calc.querySelector("[data-calc-area]");
    const chips = calc.querySelectorAll("[data-area]");
    const rates = calc.querySelectorAll("[data-rate]");
    const out = (k) => calc.querySelector(`[data-out="${k}"]`);
    /* live 128 oz price from Liquid when the section provides it */
    const p128 = parseFloat(calc.dataset.price128) || PRICE.j128;
    const p128Label = calc.dataset.price128Label || "$39.99";
    let rate = 1;
    const run = () => {
      const area = Math.max(0, Math.min(5000000, parseFloat(String(input.value).replace(/[^\d.]/g, "")) || 0));
      chips.forEach((c) => c.setAttribute("aria-pressed", String(+c.dataset.area === area)));
      const oz = (area / 1000) * rate;
      const per128 = oz > 0 ? Math.floor(128 / oz) : 0;
      const per32 = oz > 0 ? Math.floor(32 / oz) : 0;
      out("oz").textContent = oz ? `${fmt(oz, oz < 10 ? 1 : 0)} oz` : "–";
      out("oz-note").textContent = oz ? `Of concentrate per application, mixed into water to fill your sprayer.` : "Enter your lawn size.";
      out("jug").textContent = oz ? (per128 >= 1 ? `${fmt(per128)} application${per128 === 1 ? "" : "s"}` : "Less than one") : "–";
      out("jug-note").textContent = oz ? (per128 >= 1 ? `From one 128 oz jug. A 32 oz bottle gives ${per32 >= 1 ? fmt(per32) : "less than one"}.` : `At this size, ask us about a 275 gallon tote.`) : "";
      const cost = oz * (p128 / 128);
      out("cost").textContent = oz ? `$${fmt(cost, 2)}` : "–";
      out("cost-note").textContent = oz ? `Per application, using the 128 oz jug at ${p128Label}.` : "";
    };
    input.addEventListener("input", run);
    chips.forEach((c) => c.addEventListener("click", () => { input.value = fmt(+c.dataset.area); run(); }));
    rates.forEach((b) => b.addEventListener("click", () => {
      rate = +b.dataset.rate; rates.forEach((x) => x.setAttribute("aria-pressed", String(x === b))); run();
    }));
    input.addEventListener("blur", () => { const v = parseFloat(String(input.value).replace(/[^\d.]/g, "")); if (v) input.value = fmt(v); });
    run();
  });
})();
